<div class="tab-box">
  <div class="title-ind">
    <h1 class="title-tab">Documentación Pendiente de Validar</h1>
   <!--  <img src="../../../../assets/group.png" /> -->
  </div>
    <div class="acciones-tabla">
        <app-input-tabla (keyup)="applyFilter($event)"></app-input-tabla>
        <div>
          <!-- <app-nueva-entidad (click)="openDialog()"></app-nueva-entidad> -->
          <app-descargar (click)="exportAsExcel()"></app-descargar>
        </div>
      </div>
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
     <!--  <ng-container matColumnDef="id">
        <th color="primary" mat-header-cell *matHeaderCellDef mat-sort-header>
          ID
        </th>
        <td mat-cell *matCellDef="let documento">
          {{documento.id}}
        </td>
      </ng-container> -->
      <ng-container matColumnDef="nombre">
        <th color="primary" mat-header-cell *matHeaderCellDef mat-sort-header>
          NOMBRE
        </th>
        <td mat-cell *matCellDef="let documento">
          {{documento.nombre}}
        </td>
      </ng-container>
      <ng-container matColumnDef="nombreArchivo">
        <th color="primary" mat-header-cell *matHeaderCellDef mat-sort-header>
          TIPO DE DOCUMENTO
        </th>
        <td mat-cell *matCellDef="let documento">
          {{documento.nombreArchivo}}
          <!-- documentos propios 
          <ng-container *ngIf=" documento.nombreArchivo == 'seguridadSocial'" >
            <ng-container>Seguridad social</ng-container>
        </ng-container>
        <ng-container *ngIf=" documento.nombreArchivo == 'hacienda'" >
          <ng-container>Hacienda</ng-container>
       </ng-container>
        documentos centro 
       <ng-container *ngIf=" documento.nombreArchivo == 'residuosPeligrosos'" >
        <ng-container>Comunicación residuos peligrosos</ng-container>
     </ng-container>
     <ng-container *ngIf=" documento.nombreArchivo == 'residuosNoPeligrosos'" >
      <ng-container>Comunicación residuos no peligrosos</ng-container>
      </ng-container>
      <ng-container *ngIf=" documento.nombreArchivo == 'informeResiduos'" >
        <ng-container>Declaración anual residuos</ng-container>
    </ng-container>
    <ng-container *ngIf=" documento.nombreArchivo == 'hacienda'" >
      <ng-container>Hacienda</ng-container>
    </ng-container>
       documentos gestor 
        documentos transportista 
          <ng-container *ngIf=" documento.nombreArchivo == 'autorizacion1'" >
              <ng-container>Autorización 1</ng-container>
          </ng-container>-->
        </td>
      </ng-container>
      <ng-container matColumnDef="dueñoDocumento">
        <th color="primary" mat-header-cell *matHeaderCellDef mat-sort-header>
          CONTRATISTA/CENTRO/GESTOR/TRANSPORTISTA
        </th>
        <td mat-cell *matCellDef="let documento">
          <div *ngIf="documento.contratista">
            {{ documento.contratista?.nombreComercial }}
          </div>
          <div *ngIf="documento.gestor">
            {{ documento.gestor?.nombre }}
          </div>
          <div *ngIf="documento.transportista">
            {{ documento.transportista?.nombre }}
          </div>
          <div *ngIf="documento.centro">
            {{ documento.centro?.nombre }}
          </div>
          <ng-template #elseBlock>-</ng-template>
        </td>
      </ng-container>
      <ng-container matColumnDef="indicador">
        <th color="primary" mat-header-cell *matHeaderCellDef mat-sort-header>
          INDICADOR
        </th>
        <td mat-cell *matCellDef="let documento" style="display:flex;">
          <!-- <div class="documentos-indicadores">
            <img  src="../../../../../assets/pendiente-de-validar.svg" />
          </div> -->
          <div *ngIf="documento.comentariosNuevos === true" class="documentos-indicadores">
            <img  src="../../../../../assets/comentario-.svg" />
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="fechaCaducidad">
        <th color="primary" mat-header-cell *matHeaderCellDef mat-sort-header>
          FECHA DE CADUCIDAD
        </th>
        <td mat-cell *matCellDef="let documento">
          {{documento.fechaCaducidad | date: 'dd/MM/yyyy' }}
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: tableColumns; let documento" (click)="openValidation(documento.id)" class="scroll"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[10,15,20]"></mat-paginator>
  </div>
  
